/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PartNumberChangesDetailHeaderConfigurationModel} from '../services/part-number-changes-detail-configuration/models/part-number-changes-detail-header-configuration.model';

@Component({
    selector: 'app-part-number-changes-detail-header',
    templateUrl: './part-number-changes-detail-header.component.html',
    styleUrls: ['./part-number-changes-detail-header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartNumberChangesDetailHeaderComponent {
    @Input() configuration: PartNumberChangesDetailHeaderConfigurationModel;
}
